import { useQuery } from 'react-query';
import { useApi } from '../context/useApi';
import { AxiosResponse } from 'axios';

const useHomeData = () => {
  const { defaultApi } = useApi();

  const clustersCount = useQuery(
    'clustersCount',
    () => defaultApi.statisticsClustersCountGet(),
    {
      select: (response: AxiosResponse<any>) => {
        return response.data.count;
      },
    }
  );

  const productsCount = useQuery(
    'productsCount',
    () => defaultApi.statisticsProductsCountGet(),
    {
      select: (response: AxiosResponse<any>) => {
        return response.data.count;
      },
    }
  );

  const toReviewCount = useQuery(
    'toReviewCount',
    () => defaultApi.statisticsToReviewCountGet(),
    {
      select: (response: AxiosResponse<any>) => {
        return response.data.count;
      },
    }
  );

  const toReviewHospitalDistr = useQuery(
    'toReviewHospitalDistr',
    () => defaultApi.statisticsToReviewHospitalDistrGet(),
    {
      select: (response: AxiosResponse<any>) => {
        return response.data;
      },
    }
  );

    const newestClusters = useQuery(
    'newestClusters',
    () => defaultApi.statisticsNewestClustersGet(),
    {
      select: (response: AxiosResponse<any>) => {
        return response.data;
      },
    }
  );

  const isLoading =
    clustersCount.isLoading ||
    newestClusters.isLoading ||
    productsCount.isLoading ||
    toReviewCount.isLoading ||
    toReviewHospitalDistr.isLoading;

  const isError =
    clustersCount.isError ||
    newestClusters.isError ||
    productsCount.isError ||
    toReviewCount.isError ||
    toReviewHospitalDistr.isError;

  return {
    clustersCount,
    newestClusters,
    productsCount,
    toReviewCount,
    toReviewHospitalDistr,
    isLoading,
    isError,
  };
};

export default useHomeData;